import { EmptyState } from "@repo/ui/components/empty-state";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardList } from "lucide-react";

export const Route = createFileRoute("/patients/$patientId/_layout/assessments/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex h-full flex-col">
      <EmptyState className="m-auto p-8">
        <EmptyState.Icon>
          <ClipboardList className="size-4" />
        </EmptyState.Icon>
        <EmptyState.Content>
          <EmptyState.Title>No assessment selected</EmptyState.Title>
          <EmptyState.Description>Pick an assessment from the list to read what was recorded.</EmptyState.Description>
        </EmptyState.Content>
      </EmptyState>
    </div>
  );
}
